const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ---------------------------------------------------------------------------
   REFILL FORM RESCUE  (added 2026-08-29)

   /pages/rx-form posts to Shopify's /contact, but SOMETHING ON THE PAGE CALLS
   preventDefault() on its submit. Proved in a browser: the submit event fires,
   defaultPrevented is true, and NO request ever leaves the browser. A patient
   fills the form in, clicks Submit, and the page just sits there - no error, no
   email, no card. That silence is why nobody ever reported it, and it matches
   booking_page cards stopping dead on 2026-06-03 with zero emails since.

   Listens on document in the CAPTURE phase, which runs BEFORE the handler that
   cancels it, and sends the request to our own endpoint - which raises a proper
   card instead of an email nobody recognises.

   WHY IT LIVES IN constants.js: this file is 258 bytes and IS loaded as a real
   script on every page. templates/page.RXFORM.liquid is 16KB, and rewriting 16KB
   of Liquid by hand to add a dozen lines is how a template gets silently
   corrupted. assets/bw-globals.js looked like the right home but is INLINED by
   theme.liquid, so editing it does nothing - checked, not assumed. The form-id
   guard makes this inert on every other page.
   --------------------------------------------------------------------------- */
(function () {
  var API = 'https://dx8gh4ryo7.execute-api.ca-central-1.amazonaws.com/api/refill-request';
  var PHONE = '519-578-3000';
  function say(f, text, colour) {
    var m = f.querySelector('.bwMsg');
    if (!m) {
      m = document.createElement('p');
      m.className = 'bwMsg';
      m.setAttribute('role', 'status');
      m.setAttribute('aria-live', 'polite');
      m.style.cssText = 'margin:14px 0 0;font-size:15px;line-height:1.5;font-weight:600;';
      f.appendChild(m);
    }
    m.textContent = text;
    m.style.color = colour;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id !== 'refillForm') { return; }
    e.preventDefault();
    e.stopPropagation();
    var v = function (n) { var el = f.querySelector('[name="contact[' + n + ']"]'); return el ? String(el.value || '').trim() : ''; };
    var p = function (n) { var el = f.querySelector('[name="contact[' + n + ']"]:checked'); return el ? String(el.value || '').trim() : ''; };
    var data = {
      name: v('Full Name'), dob: v('Date of Birth'), phone: v('phone'), email: v('email'),
      med1: v('Medication 1'), med2: v('Medication 2'), med3: v('Medication 3'),
      med4: v('Medication 4'), med5: v('Medication 5'),
      fulfillment: p('Fulfillment'), address: v('Delivery Address'),
      preferred: v('Preferred Date'), notes: v('Notes')
    };
    if (!data.name) { say(f, 'Please tell us your name.', '#991b1b'); return; }
    if (data.phone.replace(/[^0-9]/g, '').length < 10) { say(f, 'Please enter a 10-digit phone number so we can reach you.', '#991b1b'); return; }
    if (!data.med1) { say(f, 'Please tell us at least one medication.', '#991b1b'); return; }
    var btn = f.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }
    say(f, 'Sending...', '#4b5563');
    fetch(API, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) {
        if (!r.ok) { throw new Error('http ' + r.status); }
        f.reset();
        say(f, 'Thank you - we have your refill request and the pharmacy will be in touch. If it is urgent, or you need it today, please call us on ' + PHONE + '.', '#3f6217');
        if (btn) { btn.style.display = 'none'; }
      })
      .catch(function () {
        /* Never a bare "something went wrong" - that silence IS the bug this fixes.
           If we cannot take it, they must leave knowing we did NOT get it. */
        say(f, 'Sorry - that did not go through, so we have NOT received your refill. Please call us on ' + PHONE + ' so nothing is missed.', '#991b1b');
        if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
      });
  }, true);
})();
